<template>
  <div
    :class="DS_ICON_PICKER_LIST_CLASSES.Search"
    data-cy="ds-icon-picker-list__search"
  >
    <DSBaseInput
      ref="iconPickerSearchRef"
      v-model="modelValue"
      prefix="search"
      name="icon-picker-search"
      :placeholder="props.placeholder ?? SEARCH_PLACEHOLDER"
      :disabled="props.disabled"
      :readonly="false"
      :clearable="false"
      type="search"
    />
  </div>
</template>

<script setup lang="ts">
import DSBaseInput from "@/src/design_system/form_elements/base_input/components/DSBaseInput.vue";
import { DS_ICON_PICKER_LIST_CLASSES } from "@/src/design_system/form_elements/icon_picker/constants/classes";
import type { DSIconPickerSearchProps } from "@/src/design_system/form_elements/icon_picker/types/props";
import { onMounted, useTemplateRef } from "vue";

const props = withDefaults(defineProps<DSIconPickerSearchProps>(), {
  disabled: false,
});

const iconPickerSearchRef = useTemplateRef("iconPickerSearchRef");

const SEARCH_PLACEHOLDER = window.I18n.designSystem.iconPicker.searchPlaceholder;

const modelValue = defineModel<string>({ default: "" });

onMounted(() => {
  requestAnimationFrame(() => {
    iconPickerSearchRef.value?.focus();
  });
});
</script>
